import { Carousel, Col, Layout, Row } from "antd";
import { Content } from "antd/es/layout/layout";
const ThirdtyPartner: React.FC = () => {
    return (
        <Layout className="thirdty-partner-slide">
            <Content>
                <Carousel swipeToSlide={true} autoplay swipe={true} style={{ display: "inline" }}>
                    <div style={{ display: "flex" }}>
                        <img className="slide-img" src={`${process.env.PUBLIC_URL}/assets/img/slide/1.jpg`} />
                        <img className="slide-img" src={`${process.env.PUBLIC_URL}/assets/img/slide/2.jpg`} />
                        <img className="slide-img"src={`${process.env.PUBLIC_URL}/assets/img/slide/3.jpg`} />
                        <img className="slide-img" src={`${process.env.PUBLIC_URL}/assets/img/slide/4.jpg`} />
                        <img className="slide-img" src={`${process.env.PUBLIC_URL}/assets/img/slide/5.jpg`} />
                        <img className="slide-img" src={`${process.env.PUBLIC_URL}/assets/img/slide/6.jpg`} />
                        <img className="slide-img" src={`${process.env.PUBLIC_URL}/assets/img/slide/7.jpg`} />
                        <img className="slide-img" src={`${process.env.PUBLIC_URL}/assets/img/slide/8.jpg`} />
                    </div>
                    <div>
                        <img className="slide-img" src={`${process.env.PUBLIC_URL}/assets/img/slide/7.jpg`} />
                        <img className="slide-img" src={`${process.env.PUBLIC_URL}/assets/img/slide/8.jpg`} />
                        <img className="slide-img" src={`${process.env.PUBLIC_URL}/assets/img/slide/9.jpg`} />
                        <img className="slide-img" src={`${process.env.PUBLIC_URL}/assets/img/slide/10.jpg`} />
                        <img className="slide-img" src={`${process.env.PUBLIC_URL}/assets/img/slide/11.jpg`} />
                        <img className="slide-img" src={`${process.env.PUBLIC_URL}/assets/img/slide/12.jpg`} />
                        <img className="slide-img" src={`${process.env.PUBLIC_URL}/assets/img/slide/1.jpg`} />
                        <img className="slide-img" src={`${process.env.PUBLIC_URL}/assets/img/slide/2.jpg`} />
                    </div>
                </Carousel>

            </Content>

        </Layout>
    )
}
export default ThirdtyPartner;